import { escapeRegExp } from "../helper/helpers";

export const theme_matches = (drug, illness) => {
  // drug is an object representing a drug
  // illness is an array of illnesses that might match the given drug
  if (illness.length === 0) return true;
  const illnesses_ids = illness.map((el) => el.id).concat(["199"]);

  const to_check = ["drug_assessment", "drug_interaction", "drug_factsheet"];
  for (const key of to_check) {
    for (const item of drug[key].items) {
      for (const topic_id of item.topic_ids) {
        if (illnesses_ids.includes(topic_id)) {
          return true;
        }
      }
    }
  }
  return false;
};

export const type_matches = (types, item) => {
  if (types.length === 0) return true;
  for (let i = 0; i < types.length; i++) {
    if (MAP[types[i]](item)) return true;
  }
  return false;
};

function has_drug_factsheet(item) {
  return item.drug_factsheet.items.length > 0;
}

function has_drug_assessment(item) {
  return item.drug_assessment.items.length > 0;
}

function has_drug_interaction(item) {
  return item.drug_interaction.items.length > 0;
}

const MAP = {
  "Frühe Nutzenbewertungen": has_drug_assessment,
  "Wechselwirkungen und Nebenwirkungen": has_drug_interaction,
  Factsheets: has_drug_factsheet,
};

export const drugname_matches = (item, drug_name) => {
  if (drug_name.length === 0) return true;

  const illnesses_value = drug_name.map((el) => el.value);
  const regexp = new RegExp(illnesses_value.map(escapeRegExp).join("|"));

  if (regexp.test(item.title)) {
    return true;
  }
  return false;
};
